/* eslint-disable @typescript-eslint/consistent-type-definitions */

import { flush, sink } from './sink';

export interface Logger {
  (parts: TemplateStringsArray, ...subs: any[]): void;
  (message: string, ...data: object[]): void;
  with(...props: object[]): Logger;
  seq(
    message: string,
    ...data: object[]
  ): (event: string, ...data: object[]) => Logger['seq'];
  flush(): Promise<number>;
}

export const FLOG = asLogger(sink);

let sequenceId = 0;
export function asLogger(base: typeof sink): Logger {
  function log(...args: [string, ...any[]] | [TemplateStringsArray, ...any[]]) {
    if (Array.isArray(args[0])) {
      const { message, data } = formatTemplate(
        ...(args as [TemplateStringsArray])
      );
      base(message, data);
      return;
    }
    base(...(args as [string, ...any[]]));
  }
  Object.defineProperties(log, {
    with: {
      value(...additionalProps: object[]) {
        return asLogger(logger);

        function logger(message: string, ...props: object[]) {
          base(message, ...additionalProps, ...props);
        }
      },
    },
    flush: { value: flush },
    seq: {
      value(message: string, ...data: [string, ...object[]] | object[]) {
        // eslint-disable-next-line no-plusplus
        const id = sequenceId++;
        const startMs = performance.now();
        return emit;
        function emit(event: string, ...eventData: object[]) {
          const now = performance.now();
          const atMs = now - startMs;
          base(
            `<${id}> [${event}@${atMs.toFixed(2)}] ${message}`,
            {
              seq: {
                id,
                event,
                atMs,
              },
            },
            ...(data as object[]),
            ...eventData
          );
          return emit;
        }
      },
    },
  });
  return log as Logger;
}

function formatTemplate(parts: TemplateStringsArray, ...subs: any[]) {
  const data = Object.assign({}, ...subs.filter((p) => typeof p === 'object'));
  const message = String.raw(
    parts,
    subs.map((s) => tryJson(s))
  );
  return { message, data };
}

function tryJson(x: any) {
  try {
    return JSON.stringify(x);
  } catch (__) {
    return String(x);
  }
}
